import React, {useEffect, useState} from "react";
import Basic from "./Basic";
import Goals from "./Goals";
import Curriculum from "./Curriculum/Curriculum";
import {CourseService} from "../../../service/CourseService";
import GeneralUtils from "../../../utils/GeneralUtils";
import Overview from "./Overview";
import {TabPanel, TabView} from "primereact/tabview";
import {Toolbar} from 'primereact/toolbar';
import {useNavigate, useParams} from "react-router-dom";
import {ChapterService} from "../../../service/ChapterService";
import FileService from "../../../service/FileService";
import {FILE_URL} from "../../../utils/Constants";
import {Button} from "primereact/button";
import {Panel} from "primereact/panel";
import {Menu} from "primereact/menu";
import {Steps} from "primereact/steps";
import {Tag} from "primereact/tag";
import {toast} from "react-toastify";

const defaultCourse = {
    title: '',
    headline: '',
    description: '',
    isPublished: false,
    instructionalLevelObject: null,
    instructionalLevel: '',
    category: null,
    subcategory: null,
    courseHasLabelList: [],
    objectives: [],
    prerequisites: [],
    targetAudiences: []
}
const CreateCourse = () => {
    const [course, setCourse] = useState(defaultCourse);
    const [imageFile, setImageFile] = useState();
    const [videoFile, setVideoFile] = useState();
    const [activeIndex, setActiveIndex] = useState(-1);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const {id} = useParams();


    const service = new CourseService();
    const chapterService = new ChapterService();
    const fileService = new FileService();


    useEffect(() => {
        // service.checkPage();
        if(!GeneralUtils.isNullOrEmpty(id)){
            service.findById(id)
                .then(course=> getChapterList(course))
                .then(()=> setActiveIndex(0));


        } else{
            setActiveIndex(0);
        }
    }, []);

    const save = () => {
        // console.log(!GeneralUtils.isNullOrEmpty(imageFile));
        course.instructionalLevel = course.instructionalLevelObject ? course.instructionalLevelObject.name : null;

        course.objectives = course.objectives.filter(objective=>!GeneralUtils.isNullOrEmpty(objective));
        course.prerequisites = course.prerequisites.filter(prerequisite=>!GeneralUtils.isNullOrEmpty(prerequisite));
        course.targetAudiences = course.targetAudiences.filter(targetAudience=>!GeneralUtils.isNullOrEmpty(targetAudience));

        if(checkCourse()){
            return toast.warn('Lütfen tüm alanlarını doldurun.');
        }

        setLoading(true);
        // course.image240x135 = imageFile ? FILE_URL + imageFile.name : null;
        if (GeneralUtils.isNullOrEmpty(course.id)) {
            service.create(course).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                    && GeneralUtils.isNullOrEmpty(response.error)) {
                    getChapterList(response);
                    // if(!GeneralUtils.isNullOrEmpty(imageFile)){
                    //     fileService.upload(getImageForm());
                    // }
                }
                setLoading(false);
            });
        } else{
            service.update(course).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                    && GeneralUtils.isNullOrEmpty(response.error)) {
                    getChapterList(response);
                    // if(imageFile){
                    //     fileService.upload(getImageForm());
                    // }
                }
                setLoading(false);
            });
        }
    }

    const isPublish = (status) => {
        course.instructionalLevel = course.instructionalLevelObject ? course.instructionalLevelObject.name : null;

        course.objectives = course.objectives.filter(objective=>!GeneralUtils.isNullOrEmpty(objective));
        course.prerequisites = course.prerequisites.filter(prerequisite=>!GeneralUtils.isNullOrEmpty(prerequisite));
        course.targetAudiences = course.targetAudiences.filter(targetAudience=>!GeneralUtils.isNullOrEmpty(targetAudience));

        if(checkCourse()){
            return toast.warn('Lütfen tüm alanlarını doldurun.');
        }

        course.isPublished = status;

        setLoading(true);
        service.update(course).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                getChapterList(response);
                // if(imageFile){
                //     fileService.upload(getImageForm());
                // }
            }
            setLoading(false);
        });
    }

    const checkCourse = () => {
        return GeneralUtils.isNullOrEmpty(course.title) || GeneralUtils.isNullOrEmpty(course.headline) || GeneralUtils.isNullOrEmpty(course.description)
            || GeneralUtils.isNullOrEmpty(course.instructionalLevel) || GeneralUtils.isNullOrEmpty(course.category) || GeneralUtils.isNullOrEmpty(course.subcategory)
            || GeneralUtils.isNullOrEmpty(course.courseHasLabelList) || GeneralUtils.isNullOrEmpty(course.objectives) || GeneralUtils.isNullOrEmpty(course.prerequisites)
            || GeneralUtils.isNullOrEmpty(course.targetAudiences);
    }

    const getChapterList = (course) =>{
        return chapterService.findByCourseId(course.id).then(chapterList => {
            course.instructionalLevelObject = {name: course.instructionalLevel};
            course.chapterList = chapterList;
            setCourse(course);
            // if(!GeneralUtils.isNullOrEmpty(course.image240x135)) {
            //     fileService.getFileByName(course.image240x135).then(result => setImageFile(result));
            // }
        });
    }

    const handleImage = (file) => {
        setImageFile(file);
        service.findById(course.id).then((response) => {
            setCourse({...course, image240x135: response.image240x135})
        });
    };

    const getImageForm = () => {
        const imageForm = new FormData();
        imageForm.append('file', imageFile);
        imageForm.append('name', imageFile.name);
        imageForm.append('path', "course");
        imageForm.append('id', course.id);
        return imageForm;
    }


    const countProperties= (Object.keys(course).filter(course => !GeneralUtils.isNullOrEmpty(course)).length)

    return (
        <>
            <div className="container">
            <Toolbar end={
                <div className="flex justify-content-end gap-2">
                    {(course.id && !course.isPublished) ?
                        <Button label="Yayınla" onClick={ () => isPublish(true)} loading={loading} style={{width: "100%"}} size="small" severity="danger" outlined/>
                    : (course.id && <Button label="Yayından Kaldır" onClick={() => isPublish(false)} loading={loading} style={{width: "100%"}} size="small" severity="danger" outlined/>)}
                    {course.id &&<Button label="Önizleme" onClick={() => navigate(`/course/view/${course.id}`)} loading={loading} style={{width: "100%"}} size="small" outlined/>}
                    <Button label="Kaydet" onClick={save} loading={loading} style={{width: "100%"}} size="small" raised/>
                </div>
            } className="mt-2 mb-2"/>
                {/*<div className="flex justify-content-end flex-wrap mt-3">*/}
            {/*    <Button label="Devam" onClick={save} loading={loading}/>*/}
            {/*</div>*/}
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Kurs Açılış Sayfası">
                        <Basic course={course} setCourse={data => setCourse({...course, ...data})} />
                    </TabPanel>
                    <TabPanel header="Hedef Öğrenciler">
                        <Goals course={course} setCourse={data => setCourse({...course, ...data})} />
                    </TabPanel>
                    <TabPanel header="Kurs Tanıtımı" disabled={!course.id}>
                        <Overview course={course} imageSrc={course.image240x135} imageFile={imageFile} setImageFile={file => handleImage(file)} videoFile={videoFile} setVideoFile={file => setVideoFile(file)}/>
                    </TabPanel>
                    <TabPanel header="Müfredat" disabled={!course.id}>
                        <Curriculum course={course} setCourse={data => setCourse({...course, chapterList: data})} />
                    </TabPanel>
                </TabView>
            </div>
        </>

    )
    //
    // const courseMenu = [
    //     {
    //         label: 'Kurs Açılış Sayfası',
    //         icon: (activeIndex === 0 ? 'pi pi-check-circle' : 'pi pi-circle'),
    //         command: () => {setActiveIndex(0)}
    //     },
    //     {
    //         label: 'Hedef Öğrenciler',
    //         icon: (activeIndex === 1 ? 'pi pi-check-circle' : 'pi pi-circle'),
    //         command: () => {setActiveIndex(1)}
    //     },
    //     {
    //         label: 'Kurs Tanıtımı',
    //         icon: (activeIndex === 2 ? 'pi pi-check-circle' : 'pi pi-circle'),
    //         command: () => {
    //             // if(GeneralUtils.isNullOrEmpty(course.id)){
    //             //     setActiveIndex(0)
    //             //     return toast.warn('Kurs tanıtımı için lütfen kursu kaydedin.');
    //             // }
    //             setActiveIndex(2)
    //         }
    //     },
    //     {
    //         label: 'Müfredat',
    //         icon: (activeIndex === 3 ? 'pi pi-check-circle' : 'pi pi-circle'),
    //         command: () => {
    //             // if(GeneralUtils.isNullOrEmpty(course.id)){
    //             //     setActiveIndex(0)
    //             //     return toast.warn('Müfredat için lütfen kursu kaydedin.');
    //             // }
    //             setActiveIndex(3)
    //         }
    //     }
    // ];
    //
    // const getContentWithMenu = () =>{
    //     return <div className="instructor-container">
    //                 <div className="instructor-sidebar">
    //                     <Menu model={courseMenu} style={{width: "100%"}}/>
    //                     {/*<Button label="Önizleme" onClick={save} loading={loading} style={{width: "100%"}} className="mb-3"/>*/}
    //                     <Button label="Kaydet" onClick={save} loading={loading} style={{width: "100%"}} className="mb-3"/>
    //
    //                     <Panel header="Kurs Bilgileri">
    //                         <div className="flex flex-column gap-2">
    //                             <div><b>Durum: </b> {course.isPublished ? <Tag severity="success" value="Yayınlandı"/> : <Tag severity="info" value="Taslak"/>}</div>
    //                             {course.chapterList && <div><b>Bölüm: </b>{course.chapterList.length}</div>}
    //                             {course.numOfPublishedLectures && <div><b>Ders: </b>{course.numOfPublishedLectures}</div>}
    //                         </div>
    //                     </Panel>
    //                 </div>
    //                 <div className="instructor-content">
    //                     {/*<TabView>*/}
    //                     {/*    <TabPanel header="Kurs açılış sayfası">*/}
    //                     {/*        <Basic setCourse={data => setCourse({...course, ...data})}/>*/}
    //                     {/*    </TabPanel>*/}
    //                     {/*    <TabPanel header="Hedef öğrenciler">*/}
    //                     {/*        <Goals setCourse={data => setCourse({...course, ...data})}/>*/}
    //                     {/*    </TabPanel>*/}
    //                     {/*    <TabPanel header="Müfredat">*/}
    //                     {/*        <Curriculum ref={elem => this.refCreateContent = elem}/>*/}
    //                     {/*    </TabPanel>*/}
    //                     {/*</TabView>*/}
    //                     {/*<div className="card content" >*/}
    //                     {activeIndex === 0 && <Basic course={course} setCourse={data => setCourse({...course, ...data})} />}
    //                     {activeIndex === 1 && <Goals course={course} setCourse={data => setCourse({...course, ...data})} />}
    //                     {activeIndex === 2 && <Overview imageSrc={course.image240x135} imageFile={imageFile} setImageFile={file => setImageFile(file)} videoFile={videoFile} setVideoFile={file => setVideoFile(file)}/>}
    //                     {activeIndex === 3 && <Curriculum course={course} setCourse={data => setCourse({...course, chapterList: data})} />}
    //                     {/*</div>*/}
    //                 </div>
    //     </div>
    // }
    //
    // const getContentWithStep= () =>{
    //     return <div className="flex flex-column gap-4">
    //         <Steps model={courseMenu} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={false} className="mt-4"/>
    //         {activeIndex === 0 && <Basic course={course} setCourse={data => setCourse({...course, ...data})} />}
    //         {activeIndex === 1 && <Goals course={course} setCourse={data => setCourse({...course, ...data})} />}
    //         {activeIndex === 2 && <Overview imageFile={imageFile} setImageFile={file => setImageFile(file)} videoFile={videoFile} setVideoFile={file => setVideoFile(file)}/>}
    //         {activeIndex === 3 && <Curriculum course={course} setCourse={data => setCourse({...course, chapterList: data})} />}
    //     </div>
    // }

};

export default CreateCourse;
